import SelectFilter from '../templates/SelectFilter';
import { ACCOUNT_STATUS } from '@vindr/services/constants/common.constant';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const STATUS = [
  { name: 'Inactive', value: ACCOUNT_STATUS.Inactive },
  { name: 'Active', value: ACCOUNT_STATUS.Active },
  { name: 'Expired', value: ACCOUNT_STATUS.Expired },
];

const STATUS_ACTIVE = [
  { name: 'Active', value: true },
  { name: 'Inactive', value: false },
];

const LIST_RENDER = {
  status: STATUS,
  active: STATUS_ACTIVE,
};

interface Status {
  value: string | boolean;
  title: boolean | string;
  placeholder: string;
  onChange: (value: any) => void;
  renderType?: 'status' | 'active';
  mode?: 'multiple' | 'tags';
  minWidth?: number;
  maxWidth?: number;
  width?: number;
}

const Status = ({
  value,
  title,
  placeholder,
  onChange,
  renderType = 'status',
  mode,
  width = 200,
}: Status) => {
  const { t } = useTranslation('Vindoc');

  const options = useMemo(
    () =>
      LIST_RENDER[renderType]?.map((st) => ({
        value: st.value,
        label: t(st.name),
      })),
    [renderType, t]
  );

  return (
    <SelectFilter
      {...{ width, mode, value, title, placeholder, onChange, options }}
      searchVietnamese
    />
  );
};

export default Status;
